import getAxiosInstance from '../../helpers/get_axios_instance'

class ConsultaCupo {
  constructor (args = {}) {
    const {
      numero
    } = args
    this.numero = numero
  }

  getConsulta () {
    const cpa = `{"clave":{"numero":"${this.numero}"}}`
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_carta_de_porte_automotor?r=${cpa}`)
    return promise.then((result) => {
      const { data } = result
      if (data.estado === 'exito') {
        console.log(data)
        if (data.filas_procesadas > 0) {
          return data
        } else {
        // Si devuelve filas_procesadas = 0 tengo que consultar en presunta
          const promise1 = axios.get(`/consulta_cpa_presunta?r=${cpa}`)
          return promise1.then((result) => {
            const { data } = result
            if (data.estado === 'exito') {
              console.log('data', data)
              return data
            } else {
              throw new Error('No puedo obtener Carta de Porte Automotor desde el servidor')
            }
          })
        }
      } else {
        throw new Error('No puedo obtener carta de porte automotor desde el servidor')
      }
    })
  }
}

export default ConsultaCupo
